import { debounce } from '@webikon/webentor-core/_utils';

// Normalize text for search, e.g. diacritics, uppercase, etc.
function normalizeText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * Cities list search functionality
 * - Real-time search with 300ms debounce
 * - Case-insensitive search with diacritics support
 * - Searches through city name and postal code
 * - Shows/hides no results message
 */
document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.js-cities-list-search');
  const cityItems = document.querySelectorAll('[data-search-data]');
  const noResults = document.querySelector('.js-cities-list-no-results');

  if (!searchInput || !cityItems.length) return;

  const handleSearch = (e: Event) => {
    const searchTerm = normalizeText(
      (e.target as HTMLInputElement).value.trim(),
    );

    const results = [];

    cityItems.forEach((item) => {
      const searchData = JSON.parse(item.dataset.searchData);
      const matches = searchData.some(
        (data) => data && normalizeText(data.toString()).includes(searchTerm),
      );

      item.style.display = matches ? '' : 'none';

      if (matches) {
        results.push(item);
      }
    });

    // If no results, show no results message
    if (searchTerm && !results.length) {
      noResults.classList.remove('hidden');
    } else {
      noResults.classList.add('hidden');
    }
  };

  const debouncedSearch = debounce(handleSearch, 300);
  searchInput.addEventListener('input', debouncedSearch);
});
